/**
 * Resource-node `kind` → harvest cursor tool. Mirrors the gather-SFX taxonomy in
 * audio.ts::gatherSoundForKind so the cursor icon and the gather sound never
 * disagree about which tool a node uses. The client cursor controller maps the
 * returned tool to the `harvest-<tool>` cursor asset.
 */
export type HarvestTool = "wood" | "stone" | "forage";

export function harvestCursorForKind(kind: string): HarvestTool {
  if (/tree|sapling|wood/i.test(kind)) return "wood";
  if (/gold|stone|rock|ore/i.test(kind)) return "stone";
  // berry | bush | herb | plant | mushroom | reed — and any unknown kind — forage.
  return "forage";
}
